import { Id, MessagesData, MessagesResponse as Response } from '@nextforce/api'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { useServer } from 'app/server/context'
import keys from 'chat/shared/queries/keys'
import { produce } from 'immer'

type Variables = {
  conversationId: Id
  messageId: Id
}

export function useUnmarkMessage() {
  const { server } = useServer()
  const client = useQueryClient()

  return useMutation({
    mutationFn: UnmarkMessage,
    onSuccess: async event => {
      const key = keys.messages()
      const data = client.getQueryData<MessagesData>(key)

      if (!data) {
        return
      }

      const index = data.messages.findIndex(m => m.id === event.message_id)

      if (index < 0) {
        return
      }

      await client.cancelQueries({ queryKey: key })
      client.setQueryData<MessagesData>(
        key,
        produce(data, updatedData => {
          updatedData.messages[index].isMarked = false
        })
      )
    },
  })

  function UnmarkMessage({ conversationId, messageId }: Variables) {
    return server.delete<Response.MarkedMessageEvent>(
      `/v2/chat/conversations/${conversationId}/messages/${messageId}/marked`
    )
  }
}
